module.exports = __webpack_public_path__ + "static/icons/icon-coupon-enabled.3fd07a8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon-coupon-enabled.gif
// module id = 8OIl
// module chunks = 1